/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import React, { MouseEvent } from 'react';
import anatomicalModelFeaturesConstants from '../../constants/anatomical-model-constants';
import { ExperimentConfiguration, IAnatomicalModel } from '../../models';

import { MenuItem } from './models';

export interface DropdownNavItemProps {
  item: MenuItem;
  onToggle(name: string): void;
  visibleMenu: string;
  handleItemClick: (action: string, value: string, configurationName: string) => void;
  config: ExperimentConfiguration[];
  model: IAnatomicalModel;
}

export const DropdownNavItem: React.FC<DropdownNavItemProps> = ({
  item,
  onToggle,
  visibleMenu,
  handleItemClick,
  config,
  model,
}: DropdownNavItemProps): React.ReactElement => {
  const showMenu = item.title === visibleMenu;
  const onDropdownClickHandler = (event: MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault();
    onToggle(showMenu ? '' : item.title);
  };

  const onMenuItemSelect = (menuItem: MenuItem) => {
    if (!menuItem.action) {
      return;
    }

    let newValue = menuItem.value || '';
    if (menuItem.type === 'toggle') {
      if (!menuItem.initialValue) {
        newValue = menuItem.value || '';
      } else {
        const toggleValue = menuItem.toggleValues?.find((f) => f !== menuItem.initialValue);
        newValue = toggleValue || '';
      }
    }

    handleItemClick(menuItem.action, newValue, menuItem.configurationName || '');
  };

  const renderSubItems = (items: MenuItem[]): React.ReactElement => {
    return (
      <>
        {items.map((menuItem) => {
          // TODO: refactor value assignemnts for config
          // map values for menu items from session data configuration
          // eslint-disable-next-line array-callback-return
          config?.map((confItem: ExperimentConfiguration) => {
            if (confItem.name === 'gridSizeOption' && menuItem?.name?.includes('isotropic_grid')) {
              if (menuItem.name === 'isotropic_grid__1mm' && confItem.selectedValue === '1mm') {
                menuItem.initialValue = confItem.selectedValue;
              } else if (menuItem.name === 'isotropic_grid__0p5mm' && confItem.selectedValue === '0p5mm') {
                menuItem.initialValue = confItem.selectedValue;
              } else if (menuItem.name === 'isotropic_grid__optional' && confItem.selectedValue === 'optional') {
                menuItem.initialValue = confItem.selectedValue;
              }
            }
            if (menuItem.name && confItem.name === menuItem.name) {
              if (menuItem.type === 'toggle') {
                menuItem.initialValue = confItem.selectedValue;
              } else menuItem.initialValue = undefined;
            } else if (menuItem.name?.startsWith(`${confItem.name}__`)) {
              if (menuItem.name === `${confItem.name}__${confItem.selectedValue}`) {
                menuItem.initialValue = confItem.selectedValue;
              } else {
                menuItem.initialValue = undefined;
              }
            }
          });

          return (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            <li
              key={`sub-${menuItem.title}`}
              className={`dropdown-item ${
                !model?.features?.some((f) => f.name === anatomicalModelFeaturesConstants.Isocenter) &&
                menuItem.title === 'Isocenter'
                  ? 'disabled'
                  : ''
              } ${
                !model?.features?.some((f) => f.name === anatomicalModelFeaturesConstants.defaultCardiacPhase) &&
                menuItem.title === 'Default cardiac Phase'
                  ? 'd-none'
                  : ''
              }`}
              onClick={() => onMenuItemSelect(menuItem)}
              onKeyDown={() => onMenuItemSelect(menuItem)}
            >
              {!menuItem.subMenu ? (
                <>
                  {menuItem.type === 'toggle' && menuItem.initialValue === '1' ? (
                    <span className="active-menu-item d-flex justify-content-between align-items-center">
                      {menuItem.title} <i className="fa fa-check" aria-hidden="true" />
                    </span>
                  ) : (
                    menuItem.type === 'toggle' && <span>{menuItem.title}</span>
                  )}

                  {menuItem.initialValue && menuItem.type !== 'toggle' && (
                    <span className="active-menu-item d-flex justify-content-between align-items-center">
                      {menuItem.title} <i className="fa fa-check" aria-hidden="true" />
                    </span>
                  )}
                  {!menuItem.initialValue && <span>{menuItem.title}</span>}
                </>
              ) : (
                <>
                  <span>{menuItem.title}</span>
                  <span className="pull-right dropdown-toggle">&nbsp;</span>
                  <ul className="submenu dropdown-menu dropdown-menu-lg">
                    {menuItem.subMenu && renderSubItems(menuItem.subMenu)}
                  </ul>
                </>
              )}
            </li>
          );
        })}
      </>
    );
  };

  return (
    <li className="nav-item dropdown">
      <a className="nav-link dropdown-toggle mx-2" href={item.path || '/'} onClick={onDropdownClickHandler}>
        {item.title}
      </a>
      <ul className={`dropdown-menu dropdown-menu-lg ${showMenu ? 'show' : ''}`}>
        {item.subMenu && renderSubItems(item.subMenu)}
      </ul>
    </li>
  );
};
